import { useEffect, useState } from "react";
import { Button, MenuItem, InputLabel, Select, Card, Grid, Typography, TextField, Box, Backdrop, CircularProgress, FormControl, Autocomplete } from "@mui/material"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, OutlinedInput, ListItemText, IconButton } from '@mui/material';
import { fetchAPI } from "../../utils/ApiService";
import { cardHeader, buttonStyle, cardStyle, textStyle, headerStyle, subHeaderStyle, card_icon } from "../../styles/sharedStyles";
import { forwardRef } from "react";
import React from 'react';
import LineChart from "../../utils/LineChart"
import { CustomizedSnackbar } from "../../utils/CustomizedSnackbar";
import DeleteIcon from '@mui/icons-material/Delete'
import AirIcon from '@mui/icons-material/Air';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AllOutIcon from '@mui/icons-material/AllOut';
import ArticleIcon from '@mui/icons-material/Article';
import CycloneIcon from '@mui/icons-material/Cyclone';

export const PlotsForm = (props) => {
    const [problemFormulationList, setProblemFormulationList] = useState([]);
    const [boundaryCondition, setBoundaryCondition] = useState("");
    const [problemFormulation, setProblemFormulation] = useState("");
    const [selectedModel, setSelectedModel] = useState("");
    const [targetModels, setTargetModels] = useState([]);
    const [boundaryMin, setBoundaryMin] = useState("");
    const [boundaryMax, setBoundaryMax] = useState("");
    const [geometryInputs, setGeometryInputs] = useState([]);
    const [outputVariables, setoutputVariables] = useState([]);
    const [loadopen, setLoadpen] = useState(false);
    const [geometryValues, setGeometryValues] = useState({});
    const [lineChartData, setLineChartData] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [severityType, setSeverityType] = useState("success");
    const [inputConstraints, setInputConstraints] = useState("");
    const [outputConstraints, setOutputConstraints] = useState("");


    // const headers = ['Length', 'Width', 'Height']; // Your array of headers
    const [tableData, setTableData] = useState([
        Array(geometryInputs.length).fill('')
    ]);
    useEffect(() => {
        setTableData([
            Array(geometryInputs.length).fill('')
        ])
    }, [geometryInputs])


    const handleInputChange = (rowIndex, colIndex, value) => {
        const updatedData = [...tableData];
        updatedData[rowIndex][colIndex] = value;
        setTableData(updatedData);
    };

    const addNewRow = () => {
        setTableData([...tableData, Array(geometryInputs.length).fill('')]);
    };

    const getArrayOfArrays = () => {
        const numericData = tableData.map(row =>
            row.map(cell => Number(cell))
        );
        console.log('Array of Arrays:', numericData);
        return numericData;
    };


    const deleteRow = (rowIndex) => {
        const updatedData = tableData.filter((_, index) => index !== rowIndex);
        setTableData(updatedData);
    };




    const getProblemList = async () => {
        try {
            setLoadpen(true)
            const token = localStorage.getItem("msal.idtoken");
            const { data: { data: problemList } } = await fetchAPI.get("/get_problem_formulation_list", {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            setProblemFormulationList(problemList);
            setLoadpen(false)
        } catch (error) {
            setLoadpen(false)
            console.error("Failed to fetch problem list:", error);
        }
    };

    const getMetaData = async (problemName) => {
        setLoadpen(true);

        try {

            const token = localStorage.getItem("msal.idtoken");
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };

            // Call both APIs in parallel
            const [problemRes, modalRes] = await Promise.all([
                fetchAPI.post("/get_meta_data", { problemName }, { headers }),
                fetchAPI.post("/get_models_list", { problemName }, { headers }),
            ]);

            const problemData = problemRes?.data?.data;
            const modalsList = modalRes?.data?.data;

            const input_constraints = problemData?.constraints?.input || []
            const output_constraints = problemData?.constraints?.output || []

            // Update state with response data
            setGeometryInputs(problemData?.inputs || []);
            setBoundaryCondition(problemData?.loaded_boundary || []);
            setoutputVariables(problemData?.output_variables || []);
            setInputConstraints("[" + input_constraints + "]")
            setOutputConstraints("[" + output_constraints + "]")

            setTargetModels(modalsList)

        } catch (error) {
            console.error("Failed to fetch metadata:", error);
        } finally {
            setLoadpen(false);
        }
    };

    const checkPerformanceCurveButton =
        problemFormulation &&
        selectedModel &&
        boundaryMin &&
        boundaryMax

    const handleGeometryValues = (inputName, value) => {
        setGeometryValues(prevValues => ({
            ...prevValues,
            [inputName]: value
        }));
    }

    const handleBoundarymin = (event) => {
        setBoundaryMin(Number(event.target.value));
    }

    const handleBoundarymax = (event) => {
        setBoundaryMax(Number(event.target.value));

    }

    const convertGeometriesToTable = (geometryValues, geometryInputs) => {
        if (!geometryInputs || geometryInputs.length === 0) {
            return [[]];
        }

        const headers = [...geometryInputs];

        const values = geometryInputs.map(input => {
            const value = geometryValues[input];
            return value !== undefined && value !== '' ? Number(value) : null;
        });

        return [values];
    };

    const handleProblemFormulationChange = (event, newValue) => {
        setProblemFormulation(newValue || "");
        if (newValue) {
            getMetaData(newValue);
        }
        setBoundaryMax("");
        setBoundaryMin("");
    };


    const generatePlots = async () => {
        setLoadpen(true);
        setSnackbarOpen(false)
        setLineChartData(null)

        try {

            const token = localStorage.getItem("msal.idtoken");
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };
            // const geometry_data = convertGeometriesToTable(geometryValues, geometryInputs)
            const geometry_data = getArrayOfArrays()
            const boundary_min = Number(boundaryMin)
            const boundary_max = Number(boundaryMax)

            const response = await fetchAPI.post("/plot_performance_curves", {
                selectedModel,
                geometry_data,
                boundaryMin,
                boundaryMax,
                geometryInputs,
                problemFormulation,
            }, {
                headers
            });

            if (response.status === 202 || response.status === 200) {

                const checkUploadStatus = async () => {

                    try {
                        const statusResponse = await fetchAPI.post("/upload_stats_performance_curves", { problemFormulation }, {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                            }
                        });

                        if (statusResponse.status === 200) {
                            if (statusResponse?.data?.data?.error) {
                                setSnackbarMsg(statusResponse.data.data.message)
                                setSeverityType("warning")


                            } else {

                                setSnackbarMsg("Performance plot curves successfully")
                                setSeverityType("success")
                            }
                            setLineChartData(statusResponse?.data?.data)
                            setLoadpen(false)
                            setSnackbarOpen(true)



                        }
                        else {
                            console.log('Waiting for upload status to complete...');
                            setTimeout(checkUploadStatus, 5000);
                        }

                    } catch (error) {
                        const errorMessage = error.response?.data?.message || 'Error while fetching the ploted curves data.';
                        console.error(errorMessage);
                        setLoadpen(false)
                        setSnackbarMsg(errorMessage)
                        setSeverityType("error")
                        setSnackbarOpen(true)

                    }

                };
                checkUploadStatus();

            } else {
                setLoadpen(false)
                setSnackbarMsg('Error: Unable to plot the curves')
                setSnackbarOpen(true)
                throw new Error('Error storing the result to s3');
                // setTimeout(checkUploadStatus, 2000);
            }



        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Unable to plot the curves.';
            console.log("status code : ", error.response?.data?.status)
            console.log(errorMessage)
            setLoadpen(false)
            setSnackbarMsg(errorMessage)
            setSeverityType("error")
            setSnackbarOpen(true)
        }
    };



    useEffect(() => {
        getProblemList();
    }, []);

    const handleModelChange = (event) => {
        setSelectedModel(event.target.value);

    }


    return (
        <>
            <Card variant="outlined" sx={[cardStyle]}>
                <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={[cardHeader, { marginBottom: "0px", }]}>Select a problem formulation</Typography>

                    {/* <span> <Switch onChange={handleEDA} checked={EDA}></Switch> Generate EDA Report</span> */}

                </Grid>


                <Box sx={{ width: '100%' }}>
                    {/* Row 1: Input 1 + Switch */}
                    <Grid sx={{ mb: 3 }}>
                        <Grid size={3}>
                            <FormControl fullWidth sx={{ mt: 2 }}>
                                <Autocomplete
                                    id="problem-formulation-autocomplete"
                                    options={problemFormulationList || []}
                                    value={problemFormulation || null}
                                    onChange={handleProblemFormulationChange}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select problem formulation"
                                            variant="outlined"
                                            placeholder="Search problem formulation"
                                        />
                                    )}
                                    filterOptions={(options, { inputValue }) => {
                                        return options.filter(option =>
                                            option.toLowerCase().includes(inputValue.toLowerCase())
                                        );
                                    }}
                                    isOptionEqualToValue={(option, value) => option === value}
                                    clearOnEscape
                                    selectOnFocus
                                    handleHomeEndKeys
                                />
                            </FormControl>

                            {/* <Tooltip title="This is the data shown on hover">
                            <Button>Hover me</Button>
                        </Tooltip> */}
                        </Grid>
                    </Grid>

                    {/* Row 2: Input 2 + Button */}
                </Box>

                {(geometryInputs.length > 0 || boundaryCondition || outputVariables.length > 0) ? (
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        gap={2}
                        justifyContent="space-between"
                    >
                        <Card
                            sx={{
                                // mt: 1,
                                flex: '1 1 calc(45% - 8px)',
                                minWidth: 300,
                                // p: 1,
                                padding: "15px",
                                height: (geometryInputs.length > 0 || boundaryCondition || outputVariables.length > 0) ? 205 : 'fit-content',
                                maxHeight: 205,
                                overflow: 'auto',
                                border: "none",
                                boxShadow: "0 1px 8px #d1dcf9",
                                borderRadius: "14px"
                            }}
                            variant="outlined"
                        >
                            <Typography fontWeight="fontWeightBold" sx={[{ mb: 2 }, headerStyle]}>Problem formulation details</Typography>


                            <>
                                {geometryInputs.length > 0 && (
                                    <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                        <AirIcon sx={[card_icon, { color: "#008cff" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Geometry Inputs: </span>

                                        <span style={textStyle}> {geometryInputs.join(',  ')}</span>
                                    </Typography>
                                )}

                                {boundaryCondition && (
                                    <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                        <AnalyticsIcon sx={[card_icon, { color: "#e59128" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Boundary Condition: </span>

                                        <span style={textStyle}> {boundaryCondition}</span>
                                    </Typography>
                                )}

                                {outputVariables.length > 0 && (
                                    <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                        <CycloneIcon sx={[card_icon, { color: "#1daa07" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Output Variables: </span>

                                        <span style={textStyle}> {outputVariables.join(', ')}</span>
                                    </Typography>
                                )}
                            </>

                        </Card>

                        <Card
                            sx={{
                                // mt: 1,
                                flex: '1 1 calc(55% - 8px)',
                                minWidth: 300,
                                // p: 1,
                                padding: "15px",
                                height: ((inputConstraints && inputConstraints !== '[ ]') || (outputConstraints && outputConstraints !== '[ ]')) ? 205 : 'fit-content',
                                maxHeight: 205,
                                overflow: 'auto',
                                border: "none",
                                boxShadow: "0 1px 8px #d1dcf9",
                                borderRadius: "14px"
                            }}
                            variant="outlined"
                        >
                            <Typography sx={[headerStyle, {marginBottom: "8px"}]}>Constraints</Typography>


                            <>
                                {inputConstraints && inputConstraints !== '[ ]' && (
                                    <Typography sx={[subHeaderStyle,]}>
                                        <ArticleIcon sx={[card_icon, { color: "#e0ae14" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Input Constraints: </span>

                                        <span style={textStyle}> {inputConstraints}</span>
                                    </Typography>
                                )}

                                {outputConstraints && outputConstraints !== '[ ]' && (
                                    <Typography sx={subHeaderStyle}>
                                        <ArticleIcon sx={[card_icon, { color: "#e0ae14" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Output Constraints: </span>

                                        <span style={textStyle}> {outputConstraints}</span>
                                    </Typography>
                                )}
                            </>

                        </Card>
                    </Box>) : null}
            </Card>

            {/* <Card variant="outlined" sx={[cardStyle]}>
                <Grid >
                    <Grid sx={{ display: "flex" }} container spacing={2}>
                        <Box
                            display="flex"
                            flexWrap="wrap"
                            gap={2}
                            justifyContent="space-between"
                            sx={{ width: "100%", paddingTop: "20px" }}
                        >
                            <FormControl sx={{ flex: '1 1 45%', minWidth: 250 }}>
                                <TextField
                                    id="outlined-basic-input"
                                    label="Input constraints"
                                    variant="outlined"
                                    multiline
                                    value={inputConstraints}
                                />
                            </FormControl>
                            <FormControl sx={{ flex: '1 1 45%', minWidth: 250 }}>
                                <TextField
                                    id="outlined-basic-output"
                                    label="Output constraints"
                                    variant="outlined"
                                    multiline
                                    value={outputConstraints}
                                />
                            </FormControl>
                        </Box>
                    </Grid>
                </Grid>
            </Card> */}



            <Card variant="outlined" sx={[cardStyle]}>
                <Grid >
                    <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography sx={[cardHeader, { marginBottom: "auto", marginTop: "auto" }]}>
                            Select a surrogate model for plotting performance curves
                        </Typography>


                    </Grid>
                    <Grid sx={{ display: "flex" }} container spacing={2}>

                        <Box
                            display="flex"
                            flexWrap="wrap"
                            gap={2}
                            justifyContent="space-between"
                            sx={{ width: "100%", paddingTop: "20px" }}
                        >

                            <FormControl sx={{ flex: '1 1 45%', minWidth: 250 }}>
                                <InputLabel id="select-surrogate-label">Select surrogate model</InputLabel>
                                <Select
                                    labelId="select-surrogate-label"
                                    id="surrogate-checkbox"
                                    multiple={false}
                                    value={selectedModel}
                                    onChange={handleModelChange}
                                    input={<OutlinedInput label="Select surrogate model" />}

                                >
                                    {targetModels?.map((item) => (
                                        <MenuItem key={item} value={item} >
                                            <ListItemText primary={item} />
                                        </MenuItem>
                                    ))}

                                </Select>
                            </FormControl>

                        </Box>

                    </Grid>

                    <Grid sx={{ display: "flex", justifyContent: "space-between", marginTop: "25px" }}>
                        <Typography sx={[cardHeader, { marginBottom: "16px" }]}>Provide a min and max range of boundary conditions for plotting performance curves</Typography>

                    </Grid>


                    <Box sx={{ width: '100%' }}>

                        <Box
                            display="flex"
                            flexWrap="wrap"
                            gap={2}
                            justifyContent="space-between"
                        >

                            <FormControl sx={{ flex: '1 1 40%', minWidth: 250 }}>
                                <TextField id="outlined-controlled" label="Boundary min (lower bound)" type="number" variant="outlined" value={boundaryMin} onChange={handleBoundarymin} />

                            </FormControl>


                            <FormControl sx={{ flex: '1 1 40%', minWidth: 250 }}>
                                <TextField id="outlined-controlled" label="Boundary max (upper bound)" type="number" variant="outlined" value={boundaryMax} onChange={handleBoundarymax} />

                            </FormControl>

                        </Box>
                    </Box>

                </Grid>

            </Card>


            {/* <Card variant="outlined" sx={[cardStyle]}>
                <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={cardHeader}>Provide a min and max range of boundary conditions for plotting performance curves</Typography>
                </Grid>
                <Box sx={{ width: '100%' }}>
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        gap={2}
                        justifyContent="space-between"
                    >
                        <FormControl sx={{ flex: '1 1 40%', minWidth: 250 }}>
                            <TextField id="outlined-controlled" label="Boundary min (lower bound)" type="number" variant="outlined" value={boundaryMin} onChange={handleBoundarymin} />
                        </FormControl>
                        <FormControl sx={{ flex: '1 1 40%', minWidth: 250 }}>
                            <TextField id="outlined-controlled" label="Boundary max (upper bound)" type="number" variant="outlined" value={boundaryMax} onChange={handleBoundarymax} />
                        </FormControl>
                    </Box>
                </Box>
            </Card> */}

            <Card variant="outlined" sx={[cardStyle]}>
                <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={cardHeader}>Provide geometry values for plotting performance curves</Typography>
                    {geometryInputs.length > 0 ? (<Button
                        variant="contained"
                        onClick={addNewRow}
                        sx={{ margin: '10px', backgroundColor: "#2a2aa8" }}
                    >
                        Add Row
                    </Button>
                    ) : null}
                </Grid>

                {/* {geometryInputs.length > 0 ? (
                    <TableContainer component={Paper}>
                        <Table sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>
                            <TableHead>
                                <TableRow>
                                    {geometryInputs.map((input, index) => (
                                        <TableCell
                                            key={index}
                                            align="center"
                                            sx={{
                                                border: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: 'bold',
                                                height: "30px",
                                                padding: '6px'
                                            }}
                                        >
                                            {input}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    {geometryInputs.map((input, index) => (
                                        <TableCell
                                            key={index}
                                            align="center"
                                            sx={{
                                                border: '1px solid rgba(224, 224, 224, 1)',
                                                padding: '8px'
                                            }}
                                        >
                                            <input
                                                type="number"
                                                value={geometryValues[input] || ''}
                                                onChange={(e) => handleGeometryValues(input, e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    boxSizing: 'border-box'
                                                }}
                                            />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Typography sx={{ mt: 2, textAlign: 'center', color: 'text.secondary' }}>
                        Select a problem formulation to see geometry inputs
                    </Typography>
                )} */}

                {geometryInputs.length > 0 ? (
                    <>


                        <TableContainer component={Paper}>
                            <Table sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>
                                <TableHead>
                                    <TableRow>
                                        {geometryInputs.map((header, index) => (
                                            <TableCell
                                                key={index}
                                                align="center"
                                                sx={{
                                                    border: '1px solid rgba(224, 224, 224, 1)',
                                                    fontWeight: 'bold',
                                                    padding: '6px'
                                                }}
                                            >
                                                {header}
                                            </TableCell>
                                        ))}
                                        <TableCell
                                            align="center"
                                            sx={{
                                                border: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: 'bold',
                                                padding: '6px'
                                            }}
                                        >
                                            Actions
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableData.map((row, rowIndex) => (
                                        <TableRow key={rowIndex}>
                                            {row.map((cell, colIndex) => (
                                                <TableCell
                                                    key={colIndex}
                                                    align="center"
                                                    sx={{
                                                        border: '1px solid rgba(224, 224, 224, 1)',
                                                        padding: '8px'
                                                    }}
                                                >
                                                    <input
                                                        type="number"
                                                        value={cell}
                                                        onChange={(e) =>
                                                            handleInputChange(rowIndex, colIndex, e.target.value)
                                                        }
                                                        style={{
                                                            width: '100%',
                                                            padding: '8px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '4px',
                                                            boxSizing: 'border-box'
                                                        }}
                                                    />
                                                </TableCell>
                                            ))}
                                            <TableCell align="center">
                                                <IconButton
                                                    onClick={() => deleteRow(rowIndex)}
                                                    color="#837e7e"
                                                    aria-label="delete row"
                                                    sx={{ padding: "0px" }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>





                    </>
                ) : (
                    <Typography sx={{ mt: 2, textAlign: 'center', color: 'text.secondary' }}>
                        Select a problem formulation to see geometry inputs
                    </Typography>
                )}

            </Card>


            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loadopen}
            >
                <CircularProgress size="4rem" />
            </Backdrop>
            <Card variant="outlined" sx={[cardStyle]}>
                <Button fullWidth disabled={!checkPerformanceCurveButton} variant="contained" sx={[buttonStyle, { flex: '1 1 30%', minWidth: 150 }]} onClick={generatePlots}> <span>Plot the performance curves</span></Button>
            </Card>

            {lineChartData && lineChartData.data && lineChartData.layout ?
                <Card variant="outlined" sx={cardStyle}>

                    <Grid container spacing={2} sx={{ mb: 8 }}>
                        <Grid item size={12}>
                            {<LineChart chartDataJson={lineChartData} />}

                        </Grid>
                    </Grid>
                </Card> : ''}

            <CustomizedSnackbar action={snackbarOpen} message={snackbarMsg} severityType={severityType} />

        </>
    )
}